export default __webpack_public_path__ + "static/media/icon-circle-contracts-header.69e310d0.svg";